/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import LoadingCircularElemCntr from 'app/components/progress/LoadingCircularElemCntr'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import {App} from '../App'
import {useAuthProvider} from '../modules/auth'
import {PrivateRoutes} from './PrivateRoutes'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

function MissingSubscription() {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center h-100'>
      <h1>Missing Subscription</h1>
      <h4 className='mt-5'>
        You do not have access to this application. Please contact your administrator.
      </h4>
    </div>
  )
}

function Loading() {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center h-100'>
      <h1>Loading</h1>
      <h4 className='mt-5'>Please wait while we load your account information.</h4>
    </div>
  )
}

export default function AppRoutes() {
  const {currentUser} = useAuthProvider()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        {!currentUser ? (
          <>
            <Route path='loading' element={<LoadingCircularElemCntr />} />
            <Route path='/*' element={<Navigate to='/loading' />} />
          </>
        ) : (
          <Route element={<App />}>
            {currentUser.tenants.length === 0 ? (
              <>
                <Route path='missing_subscription' element={<MissingSubscription />} />
                <Route path='/*' element={<Navigate to='/missing_subscription' />} />
              </>
            ) : (
              <>
                <Route path='/*' element={<PrivateRoutes />} />
              </>
            )}
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
